// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const Formatting = t.struct({
    dateFields: t.list(t.String, 'DateFields')
});

export const getDefaultState = () =>
    new Formatting({
        dateFields: [
            'expirationDate'
        ]
    });

export default Formatting;



// WEBPACK FOOTER //
// ./src/reports/warranty-expiration/state/formatting.js